<template>
	<v-toolbar class="mb-4">
		<v-toolbar-title>
			<slot />
		</v-toolbar-title>
		<v-spacer />
		<v-toolbar-items class="hidden-sm-and-down">
			<slot name="actions" />
		</v-toolbar-items>
	</v-toolbar>
</template>

<script>
export default {
	name: "TitleView",
	components: {},
	props: [],
	data () {
		return {};
	},
	computed: {},
	watch: {},
	created () {},
	mounted () {},
	updated () {},
	destroyed () {},
	methods: {},
};
</script>

<style scoped>
</style>
